import axios from "axios";
import BASE_URL from "../../config";

// Get the auth token from localStorage and return headers
const getAuthHeader = () => {
    const tokenData = JSON.parse(localStorage.getItem("authUser") || "{}");
    return {
        Authorization: `Bearer ${tokenData.accessToken}`,
        'Content-Type': 'application/json'
    };
};

export const getGiftCards = async (filter = {}) => {
    try {
        const response = await axios.post(`${BASE_URL}/api/GiftCardConfiguration/get`, filter, {
            headers: getAuthHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching gift cards:", error);
        throw error;
    }
};

export const saveGiftCard = async (giftCard) => {
    try {
        const response = await axios.post(`${BASE_URL}/api/GiftCardConfiguration/save`, giftCard, {
            headers: getAuthHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("Error saving gift card:", error);
        throw error;
    }
};

export const getGiftCardBalance = async (code) => {
    try {
        const response = await axios.get(`${BASE_URL}/api/GiftCardConfiguration/get-balance/${code}`, {
            headers: getAuthHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching gift card balance:", error);
        throw error;
    }
};


export const generateUniqueGiftCardCode = async () => {
    try {
        const response = await axios.get(`${BASE_URL}/api/GiftCardConfiguration/generate-code`, {
            headers: getAuthHeader(),
        });
        return response.data.code || response.data.Code;
    } catch (error) {
        console.error("Error generating unique gift card code:", error);
        throw error;
    }
};
